import React, { Component } from "react";
import Popup from "reactjs-popup";
import UserService from "./User.service";
import "./User.scss";
import defaultUserImage from "./../../../../assets/image/icon/profile black.png";

export default class User extends Component {
    state = {
        isLoading: false
    };

    stopSharing = () => {
        this.setState({
            isLoading: true
        });
        UserService.stopSharing(
            this.props.share.id,
            this.props.userInfo.username,
            this.props.userInfo.token
        )
            .then(user => {
                this.props.removeUserShared(this.props.share.receiver);
            })
            .catch(error => {
                this.props.alert({
                    theme: "error",
                    message: error.message
                });
                this.setState({
                    isLoading: false
                });
            });
    };

    render() {
        const userCard = (
            <div className="position-relative user-card d-flex flex-column justify-content-center align-items-center mx-1">
                {!this.props.share.is_accepted ? (
                    <div className="user-card-pending badge badge-pill badge-warning position-absolute">
                        Pending
                    </div>
                ) : (
                    ""
                )}
                <div className="user-card-img">
                    <img
                        src={
                            this.props.share.receiver.imageUrl ||
                            defaultUserImage
                        }
                        alt=""
                    />
                </div>
                <div className="user-card-info d-flex flex-column justify-content-center align-items-center">
                    <div className="user-card-name">
                        {
                            this.props.share.receiver.name +
                            " " +
                            this.props.share.receiver.last_name
                        }
                    </div>
                    <div className="user-card-description">
                        @{this.props.share.receiver.username}
                    </div>
                </div>
            </div>
        );

        return (
            <Popup
                trigger={userCard}
                position="bottom center"
                contentStyle={{
                    border: "none",
                    display: "flex",
                    width: "auto",
                    justifyContent: "center"
                }}
            >
                <button
                    className="btn btn-danger btn-stop-sharing"
                    onClick={this.stopSharing}
                >
                    {this.state.isLoading ? (
                        <div
                            id="btn-login-spinner"
                            className="spinner-border spinner-border-sm text-light"
                            role="status"
                        >
                            <span className="sr-only">Loading...</span>
                        </div>
                    ) : (
                        "Stop sharing"
                    )}
                </button>
            </Popup>
        );
    }
}
